import { snapshot } from 'valtio';
import { CredentialsType } from '../connector-configure-types';
import ConnectorConfigureFormStore from '../stores/connector-configure-form-store';
import ConnectorConfigureStore from '../stores/connector-configure-store';

export const shouldDisableConnect = (
  connectionType: CredentialsType,
): boolean => {
  const {
    hostURL,
    token,
    password,
    name,
    clientId,
    secretKey,
    awsRoleArn,
    awsExternalId,
    awsAccessKey,
    awsAccessSecret,
    tenant,
  } = snapshot(ConnectorConfigureFormStore);

  const { invalidForm, selectedConnector } = snapshot(ConnectorConfigureStore);
  if (invalidForm) {
    return true;
  }

  if (!selectedConnector) {
    throw new Error('No selected connector found');
  }

  const invalidHostURL = !hostURL || hostURL === '';
  const invalidToken = !token || token === '';
  const invalidName = !name || name === '';
  const invalidPassword = !password || password === '';
  const invalidAccessKeyId = !clientId || clientId === '';
  const invalidSecretAccessKey = !secretKey || secretKey === '';
  const invalidAwsRoleArn = !awsRoleArn || awsRoleArn === '';
  const invalidAwsExternalId = !awsExternalId || awsExternalId === '';
  const invalidAwsAccessKey = !awsAccessKey || awsAccessKey === '';
  const invalidAwsAccessSecret = !awsAccessSecret || awsAccessSecret === '';
  const invalidApiKeyCred = !token || token === '';

  const invalidTenant = !tenant || tenant === '';

  switch (connectionType) {
    case CredentialsType.None:
      return true;
    case CredentialsType.Token:
      return invalidToken || invalidHostURL;
    case CredentialsType.UserPassword:
      return invalidName || invalidPassword || invalidHostURL;
    case CredentialsType.TokenAndUser:
      return invalidToken || invalidName || invalidHostURL;
    case CredentialsType.ClientIdSecretKey:
      return invalidAccessKeyId || invalidSecretAccessKey;
    case CredentialsType.AWSAssumeRole:
    case CredentialsType.AWSAssumeRoleCloudFormation:
    case CredentialsType.AWSOrganizationConnection:
      return invalidAwsRoleArn || invalidAwsExternalId;
    case CredentialsType.AWSAssumeRoleOnprem:
    case CredentialsType.AWSAssumeRoleCloudFormationOnprem:
    case CredentialsType.AWSOrganizationConnectionOnprem:
      return (
        invalidAwsRoleArn ||
        invalidAwsExternalId ||
        invalidAwsAccessKey ||
        invalidAwsAccessSecret
      );
    case CredentialsType.IdentityProvider:
      return false;
    case CredentialsType.UserPasswordAndTenant:
      return invalidTenant || invalidPassword || invalidName || invalidHostURL;
    case CredentialsType.ApiKey:
      return invalidApiKeyCred;
    default:
      return true;
  }
};
